module.exports = __webpack_public_path__ + "img/0706-不闪星星-07.f9ba4eb6.png";